/* eslint-disable no-console */

import { Box } from '@mui/material'
import { useOperationsStore } from '@operations/AppProvider'
import { EquipmentPlanningContent } from '@operations/features/equipmentPlanning/components/molecules/EquipmentPlanningContent'
import { useMinimalsTheme } from '@tom-ui/ui'
import { PATHS, useAsyncFetch, withAuthenticationRequired } from '@tom-ui/utils'
import { FC } from 'react'
import { useNavigate, useParams } from 'react-router'
import { EquipmentPlanningHeader } from '../../features/equipmentPlanning/components/molecules/EquipmentPlanningHeader'

const EquipmentPlanning: FC = withAuthenticationRequired(() => {
  const { equipmentPlanningUIStore } = useOperationsStore()
  const { id } = useParams()
  const theme = useMinimalsTheme()
  const navigate = useNavigate()

  const visitId = Number(id)
  if (!visitId) {
    navigate(PATHS.visits.vesselVisits.url)
  }

  useAsyncFetch(async () => {
    await equipmentPlanningUIStore.fetchData(visitId)
  }, [visitId, equipmentPlanningUIStore])

  return (
    <Box
      sx={{
        bgcolor: theme.palette.grey[100],
        minHeight: '100%',
      }}
    >
      <EquipmentPlanningHeader visitId={visitId} />
      <EquipmentPlanningContent equipmentPlanningUIStore={equipmentPlanningUIStore} />
    </Box>
  )
})

export default EquipmentPlanning
